module.exports = __webpack_public_path__ + "img/plan-bronze.4998595d.svg";